
<template>
  <Loader v-if="loader" />

    <div class="card">
      <div class="formgrid grid ">
          <div class="field col-12 md:col-3">
              <label>Fornitore</label>
              <Dropdown v-model="selectedFornitore" :options="fornitori" :filter="true" optionLabel="ragsoc" optionValue="id" placeholder="Seleziona fornitore" :class="['inputfield w-full',{'p-invalid': validationErrors.fornitore && submitted}]" />
              <div v-show="validationErrors.fornitore && submitted" class="p-error">Seleziona fornitore.</div>
          </div>
          <div class="field col-12 md:col-3">
              <label>Emissione</label>
              <Calendar v-model="data_emissione" :showIcon="true" view="year" dateFormat="yy" :class="['inputfield w-full',{'p-invalid': validationErrors.data_emissione && submitted}]" />
              <div v-show="validationErrors.data_emissione && submitted" class="p-error">Seleziona anno.</div>
          </div>
          <div class="field col-12 md:col-3">
              <label>Competenza</label>
              <Calendar v-model="data_competenza" :showIcon="true" view="year" dateFormat="yy" :class="['inputfield w-full',{'p-invalid': validationErrors.data_competenza && submitted}]" />
              <div v-show="validationErrors.data_competenza && submitted" class="p-error">Seleziona anno.</div>
          </div>
          <div class="field col-12 md:col-3 flex align-items-end justify-content-center">
              <Button label="Cerca" icon="pi pi-search" iconPos="left" class="w-full" @click="searchData" />
          </div>
      </div>
  </div>

  <div class="card">
      <DataTable ref="dt" :value="invoices" :paginator="true" :rows="10" :filters="filters" 
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10,20,50]" responsiveLayout="scroll"
          currentPageReportTemplate="{first} a {last} di {totalRecords}">
          <template #header>
            <div class="flex justify-content-between flex-wrap">
                <div class="flex align-items-center justify-content-center mb-2">
                   <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                  </span>
                </div>
                <div class="flex align-items-center justify-content-center">
                   <Button icon="pi pi-download" label="Esporta" @click="exportCSV($event)" class="p-button-secondary" />
                </div>
            </div>
          </template>
          
          <template #empty>
              <div class="text-center">Nessun dato trovato.</div>
          </template>
          <Column field="tipo_documento" header="Tipo" :sortable="true" />
          <Column field="N_FATTURA_DEF" header="Fattura" :sortable="true" />
          <Column field="EMISSIONE" header="Data emissione" :sortable="true">
            <template #body="{data}">
              {{formatDate(data.EMISSIONE)}}     
            </template>
          </Column>
          <Column field="INIZIO_COMP" header="Competenza da" :sortable="true">
            <template #body="{data}">
              {{formatDate(data.INIZIO_COMP)}}     
            </template>
          </Column>
          <Column field="FINE_COMP" header="Competenza a" :sortable="true">
            <template #body="{data}">
              {{formatDate(data.FINE_COMP)}}     
            </template>
          </Column>
          <Column field="DENOMINAZIONE" header="Azienda" :sortable="true" />
          <Column field="totale_cmor" header="Totale Cmor" :sortable="true" style="text-align:right">
            <template #body="{data}">
              {{data.totale_cmor.toFixed(2)}}     
            </template>
          </Column>
          <Column field="bollo" header="Bollo" :sortable="true" style="text-align:right" />
          <Column field="totale_imponibile" header="Totale Imponibile" :sortable="true" style="text-align:right">
            <template #body="{data}">
              {{data.totale_imponibile.toFixed(2)}}     
            </template>
          </Column>
          <ColumnGroup type="footer">
            <Row>
                <Column footer="Totale:" :colspan="7" footerStyle="text-align:right"/>
                <Column style="text-align:right" :footer="totalBollo" />
                <Column style="text-align:right" :footer="total" />
            </Row>
        </ColumnGroup>
      </DataTable>
  </div>




</template>

<script>
import moment from 'moment'
import Service from '@/services/ask-pratiche/pratiche-service'
import { ref, onMounted, getCurrentInstance, computed } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'


export default {
    components: {
      Loader
    },
    setup() {

      const dt = ref();
      const loader = ref(false)
      const invoices = ref([]);
      const filters = ref({
          'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      });
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const formatDate = self.appContext.config.globalProperties.$formatDate
      const service = new Service(self.$http, self.$eventBus)
      const data_emissione = ref();
      const data_competenza = ref();
      const fornitori = ref([]);
      const selectedFornitore = ref('')
      const validationErrors = ref({})
      const submitted = ref(false)

      onMounted(() => {       
          getFornitoriHasDetails()               
      })
      const searchData = () => {
        submitted.value = true;
        if (validateData()) {
          loader.value = true
          service.getBilancioFattFornitori(
            moment(data_emissione.value).format('YYYY'),
            moment(data_competenza.value).format('YYYY'),
            selectedFornitore.value,
          ).then((res) => {
            invoices.value = res.items      
          }).finally(() => {
              loader.value = false
          })
        }
      }

      const getFornitoriHasDetails = () =>{
        loader.value = true
        service.getFornitoriControlloFattureHasDetailsEe().then((res) => {
          fornitori.value = res.items
        }).finally(() => {
          loader.value = false
        })
      }

      const total = computed(() => {
          let total = 0;
          for(let invoice of invoices.value) {
              total += invoice.totale_imponibile;
          }
          return formatCurrency(total);
      });

      const totalBollo = computed(() => {
          let total = 0;
          for(let invoice of invoices.value) {
              total += invoice.bollo;
          }
          return formatCurrency(total);
      });

      const formatCurrency = (value) => {
        return value.toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
      };


      const validateData = () =>{
          if (data_emissione.value == null)
            validationErrors.value['data_emissione'] = true;
          else 
            delete validationErrors.value['data_emissione'];
          
          if (data_competenza.value == null)
            validationErrors.value['data_competenza'] = true;
          else 
            delete validationErrors.value['data_competenza'];

        if (selectedFornitore.value == '')
            validationErrors.value['fornitore'] = true;
          else 
            delete validationErrors.value['fornitore'];
    
        return !Object.keys(validationErrors.value).length;
      }

      const exportCSV = () => {
        dt.value.exportCSV();
      };


      return { 
        dt,
        invoices,
        loader, 
        filters, 
        data_emissione,
        data_competenza,
        fornitori,
        selectedFornitore,
        searchData,
        total,
        totalBollo,
        formatDate,
        exportCSV,
        validationErrors,
        submitted
      }
  }
}
</script>

<style scoped>

</style>
